import script from "./PrimaryEnrollmentChart.vue?vue&type=script&setup=true&lang=js"
export * from "./PrimaryEnrollmentChart.vue?vue&type=script&setup=true&lang=js"

import "./PrimaryEnrollmentChart.vue?vue&type=style&index=0&id=72ee5b4b&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-72ee5b4b"]])

export default __exports__